import { lightMode, darkMode } from './colors';

type ColorToken = keyof typeof lightMode | keyof typeof darkMode;

const checkDarkMode = () => {
  return false;
  const system = matchMedia('(prefers-color-scheme: dark)');
  const theme = localStorage.getItem('theme');
  return theme === 'dark' || system.matches;
};

const getColors = (token: ColorToken) => {
  const isDarkMode = checkDarkMode();
  const color = isDarkMode ? darkMode[token as ColorToken] : lightMode[token as ColorToken];
  const defaultCallbackColor = darkMode[token as ColorToken] || lightMode[token as ColorToken] || '';
  return color || defaultCallbackColor;
};

const colors = {
  // Red
  red: '#D20000' as '#D20000',
  red2: '#D1220D' as '#D1220D',
  red3: '#E84C3D' as '#E84C3D',
  red4: '#F73119' as '#F73119',
  red5: '#FF3219' as '#FF3219',

  // Grey
  grey: '#433833' as '#433833',
  grey2: '#777777' as '#777777',
  grey3: '#828282' as '#828282',
  grey4: '#EEEEEE' as '#EEEEEE',
  grey5: '#ECF0F1' as '#ECF0F1',
  grey6: '#2D2D2D26' as '#2D2D2D26',
  grey7: '#272421' as '#272421',
  grey8: '#BEC3C7' as '#BEC3C7',
  grey9: '#676767' as '#676767',
  grey16: getColors('--grafite-grafite-600'),
  grey10: '#F2F2F2' as '#F2F2F2',
  grey11: getColors('--grafite-grafite-100'),
  grey12: '#DEDDDB' as '#DEDDDB',
  grey13: '#E1E1E1' as '#E1E1E1',
  grey14: '#172026' as '#172026',
  grey15: getColors('--grafite-grafite-10'),

  // Backgrounds
  background1: '#E9E8E7' as '#E9E8E7',
  background2: '#F5F5F5' as '#F5F5F5',
  background3: getColors('--grafite-grafite-75'),
  background4: '#4F4C4A' as '#4F4C4A',

  // Black
  black: '#000000' as '#000000',

  // Green
  green: '#27AE61' as '#27AE61',
  green2: '#EAF7F0' as '#EAF7F0',
  green3: '#519F51' as '#519F51',
  green4: getColors('--alertas-verde-verde-90'),
  green10: getColors('--alertas-verde-verde-90'),
  green5: '#138544' as '#138544',

  // Shadowns
  shadown1: '#0000001A' as '#0000001A',
  shadown2: '#00000040' as '#00000040',
  shadown3: '#00000026' as '#00000026',
  shadown4: '#2D2D2D66' as '#2D2D2D66',
  shadown5: '#00000030' as '#00000030',
  shadown6: '#0000000D' as '#0000000D',
  shadown7: '#37322D40' as '#37322D40',
  shadown8: '#ffffff1f' as '#ffffff1f',
  transparent: '#00000000' as '#00000000',

  // Color Palet from Figma

  alert: {
    // BLUE
    blue10: getColors('--alertas-azul-azul-10'),
    blue50: getColors('--alertas-azul-azul-50'),
    blue100: getColors('--alertas-azul-azul-100'),
    blue200: '#2C97DF' as '#2C97DF',

    // GREEN
    green50: getColors('--alertas-verde-verde-10'),
    green100: getColors('--alertas-verde-verde-50'),
    green110: getColors('--alertas-verde-verde-100'),
    green300: getColors('--alertas-verde-verde-100'),
    green200: getColors('--alertas-verde-verde-75'),

    // ORANGE
    orange50: getColors('--alertas-laranja-laranja-10'),
    orange70: getColors('--alertas-laranja-laranja-70'),
    orange100: getColors('--alertas-laranja-laranja-50'),
    orange200: getColors('--alertas-laranja-laranja-60'),
    orange300: getColors('--alertas-laranja-laranja-100'),

    // RED
    red50: getColors('--alertas-vermelho-vermelho-10'),
    red100: getColors('--alertas-vermelho-vermelho-50'),
    red200: getColors('--alertas-vermelho-vermelho-100'),
  },

  borders: {
    border1: '#D6D8DB' as '#D6D8DB',
  },

  brand: {
    red: getColors('--brand---vermelho'),
    row: getColors('--brand-grafite-grafite-médio'),
    white: getColors('--brand---branco'),
    yellow: getColors('--brand---amarelo'),
    grafite: getColors('--brand---grafite'),
  },

  gray: {
    gray0: '#FAFAFA' as '#FAFAFA',
    gray10: getColors('--grafite-grafite-50'),
    gray20: getColors('--grafite-grafite-200'),
    gray30: getColors('--grafite-grafite-300'),
    gray40: getColors('--grafite-grafite-400'),
    gray50: getColors('--grafite-grafite-500'),
    gray60: getColors('--grafite-grafite-600'),
  },
  loading: {
    stroke: '#E0E0E0',
    indicator: '#6B6B6B',
    primary: '#F7F7F7',
    secondary: '#E0E0E0',
  },
};

export default colors;
